import "./external/axios/index.es.js";
import m from "./config.es.js";
import p from "./external/axios/lib/axios.es.js";
const v = {
  client: p.create(m),
  request: async function({
    extended: t,
    throwError: r = !0,
    responseType: o = "json",
    method: n = "GET",
    headers: u = {},
    ...c
  }) {
    try {
      const e = await this.client.request({
        responseType: o,
        method: n,
        headers: u,
        ...c
      }) ?? {}, s = e.status >= 200 && e.status < 300;
      if (r && !s) throw e;
      return {
        success: s,
        code: e.status,
        data: e.data,
        message: e.statusText,
        headers: t ? e.headers : void 0
      };
    } catch (e) {
      const {
        response: s = {},
        status: i = void 0,
        data: d = void 0,
        statusText: h = "",
        headers: f = void 0
      } = typeof e == "object" ? e : {}, a = {
        success: !1,
        code: i || s.status || s.statusCode,
        message: h || s.statusText,
        data: d || s.data,
        headers: t ? f || s.headers : void 0,
        error: e
      };
      if (r) throw a;
      return a;
    }
  },
  get: async function(t) {
    return this.request({ method: "GET", ...t });
  },
  post: async function(t) {
    return this.request({ method: "POST", ...t });
  },
  patch: async function(t) {
    return this.request({ method: "PATCH", ...t });
  },
  put: async function(t) {
    return this.request({ method: "PUT", ...t });
  },
  delete: async function(t) {
    return this.request({ method: "DELETE", ...t });
  }
};
export {
  v as httpService
};
